import {HigoHostMaps, getHost} from '@xc/hiya-host'
import {isNode} from '../index'
import replaceHostConfig from './replaceHost'

export const isProd = ENV === 'production'
// version 域名替换
replaceHostConfig(HigoHostMaps)

export const {
  auto,
  prod,
  replaceAutoHost,
  replaceAutoHostBgImg,
  replaceAutoHostStyle,
} = (() => {
  let host: string
  if (!isNode()) {
    host = window.location.host
  }
  return getHost({
    HostMaps: HigoHostMaps,
    host,
    env: isProd ? 'prod' : 'test',
  })
})()

export const HostMaps = {
  auto: {
    websit: isProd
      ? `https://${auto['me-live-websit']}`
      : `http://${auto['me-live-websit']}`,
    web: isProd ? `https://${auto['hiya-web']}` : `http://${auto['hiya-web']}`,
    activity: isProd ? `https://${auto.activity}` : `http://${auto.activity}`,
    version: isProd ? `https://${auto.version}` : `http://${auto.version}`,
    img01: `http://${auto.img01}`,
    video01: `http://${auto.video01}`,
    otherStatic: `https://${auto['other-static']}`,
    api: isProd ? `https://${auto.api}` : `http://${auto.api}`,
  },
  prod: {
    activity: `https://${prod.activity}`,
    version: `https://${prod.version}`,
    video01: `http://${prod.video01}`,
    img01: `http://${prod.img01}`,
    api: `https://${prod.api}`,
  },

  // 因为 higo 没有迁移 ToyBricks，所以 higo 项目中需要使用hiya的搭建地址
  ActivityToyBricksProdOrigin: 'https://activity-hiya-web.mehiya.com',
  ActivityToyBricksTestOrigin: 'http://me-hiya-web-activity-test.ixiaochuan.cn',
}
